import React from 'react'
import classNames from 'classnames'
import {
  BitcoinTile,
  EthereumTile,
  SolanaTile,
  BnbTile,
  XrpTile,
  CardanoTile,
  DogecoinTile,
} from '@/assets/icons/cryptoAssetBadges'
import { getCryptoAssetTicker, getCryptoAssetName } from '@/features/market/utils/cryptoEvent'

const TILES = {
  BTC: BitcoinTile,
  ETH: EthereumTile,
  SOL: SolanaTile,
  BNB: BnbTile,
  XRP: XrpTile,
  ADA: CardanoTile,
  DOGE: DogecoinTile,
}

/** True when the market's base asset has a logo tile; unknown tickers keep their outcome thumbnail. */
export const hasCryptoAssetBadge = question => Boolean(TILES[getCryptoAssetTicker(question)])

/**
 * Square logo tile of a crypto price market's base asset, same frame as an outcome thumbnail.
 * Renders nothing for unknown tickers.
 */
const CryptoAssetBadge = ({ question, className }) => {
  const Tile = TILES[getCryptoAssetTicker(question)]
  if (!Tile) return null
  return (
    <span
      role="img"
      aria-label={getCryptoAssetName(question)}
      className={classNames(
        'block shrink-0 overflow-hidden rounded-[var(--radius-xs)] [&>svg]:block [&>svg]:w-full [&>svg]:h-full',
        className
      )}>
      <Tile />
    </span>
  )
}

export default CryptoAssetBadge
